export const capitalize = (text: string) => {
  const str = text.split(' ');
  return str
    .map((word) => {
      if (word.length > 0) return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();

      return '';
    })
    .join(' ');
};
